module.exports = __webpack_public_path__ + "img/FirstResult_Dark.5b3e3666.jpg";